module.exports = __webpack_public_path__ + "static/media/example-3.46c2e79c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HearthHouse/example-3.jpg
// module id = 205
// module chunks = 0